import { Component, ChangeDetectionStrategy, inject} from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class DashboardComponent {
  public loading: boolean = false;
  public environment = environment;

  public sharedService: SharedService = inject(SharedService);
  public router: Router = inject(Router);

}
